var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-404"},[_c('h1',{staticClass:"p-404__title"},[_vm._v("\n        Strona nie istnieje\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"type":"prev","to":"/"}},[_vm._v("\n        Wróć\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }